import * as React from 'react';

import { SvgConstantDarkModeBackgroundColor } from '../SvgConstants';
import { ThemedSvgProps } from './hocTypings';
import { getDisplayName } from './utils';

export function asThemedDarkSvg<
    C extends React.ComponentType<React.ComponentProps<C>>,
    ResolvedProps = JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
>(WrappedComponent: C) {
    return class AsThemedDarkSvg extends React.PureComponent<ThemedSvgProps> {
        static displayName = `asThemedDarkSvg(${getDisplayName(WrappedComponent)})`;

        static defaultProps = {
            className: 'ddbc-svg--themed-dark',
        };

        render() {
            return (
                <WrappedComponent
                    {...(this.props as any)}
                    fillColor={this.props.theme.themeColor}
                    backgroundColor={SvgConstantDarkModeBackgroundColor}
                />
            );
        }
    };
}
